/**
 * The content container every Learning Center screen uses (design skill,
 * "Content area": px-4 pt-4 pb-6 sm:px-6 lg:px-8 lg:pt-5, max-w-[1700px] for
 * data-dense tools). Layout's <main> carries no padding of its own so the
 * course player can use the content area edge to edge (G13); every other
 * screen wraps itself in this class instead of hand-rolling its own gutter.
 */
export const lmsPageCls = 'mx-auto w-full max-w-[1700px] space-y-4 px-4 pt-4 pb-6 sm:px-6 lg:px-8 lg:pt-5';
